// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1rweD","title":"Header_title__3u-d-","side":"Header_side__bIrYr"};